import BasicLayout from '@/layout/BasicLayout.vue'

const opsRouter = {
  path: '/ops',
  component: BasicLayout,
  children: [
    {
      path: '/ops/customer',
      component: () => import('@/views/ops/customer/index.vue')
    },
    {
      path: "/ops/apply-list",
      component: () => import("@/views/ops/apply-list/index.vue"),
      children: [
        {
          path: '/ops/apply-list/bind',
          component: () => import('@/views/ops/apply-list/bind-apply/index.tsx')
        },
        {
          path: '/ops/apply-list/create',
          component: () => import('@/views/ops/apply-list/create-apply/index.tsx')
        },
       ]
    },
    {
      path: "/ops/work-record",
      component: () => import("@/views/ops/work-record/index.vue"),
      children: [
      {
        path: '/ops/work-record-list',
        component: () => import('@/views/ops/work-record/list/index.vue')
      },
      {
        path: '/ops/work-record-history',
        component: () => import('@/views/ops/work-record/history/index.vue')
      },
      {
        path: '/ops/report',
        component: () => import('@/views/ops/work-record/report/index.vue')
      },
      {
        path: '/ops/category',
        component: () => import('@/views/ops/work-record/category/index.vue')
      },
      {
        path: '/ops/statistic',
        component: () => import('@/views/ops/work-record/statistic/index.vue')
      }]
    },
    {
      path: '/ops/knowledge-library',
      component: () => import('@/views/ops/knowledge-library/index.vue')
    },
    {
      path: '/ops/machine',
      component: () => import('@/views/ops/machine/index.vue')
    },
    {
      path: '/ops/settings',
      component: () => import('@/views/ops/settings/index.vue')
    }
  ]
}

export default opsRouter
